/**
 * Endpoint methods related to Customers
*/

import API from "./Api";

export default {
  /**
   * Gets subscription related to the Logged-In Instance
  */
  async getOwn() {
    return API.get("/subscriptions/read", "MOODLE_SESSION_JSON");
  },

  async getByCompany(form) {
    return API.post("/subscriptions/readbycompany", form, "MOODLE_SESSION_JSON");
  }

}